import React, { useState, useEffect } from 'react';
import { gamificationService } from '../../services/firestoreService';
import './Leaderboard.css';

const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [period, setPeriod] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLeaderboard = async () => {
      setLoading(true);
      try {
        const data = await gamificationService.getLeaderboard(period, 50);
        setLeaderboard(data);
      } catch (error) {
        console.error('Error loading leaderboard:', error);
      } finally {
        setLoading(false);
      }
    };

    loadLeaderboard();
  }, [period]);

  const getRankIcon = (index) => {
    if (index === 0) return '🥇';
    if (index === 1) return '🥈';
    if (index === 2) return '🥉';
    return `#${index + 1}`;
  };

  return (
    <div className="leaderboard-container">
      <h2>🏆 Leaderboard</h2>

      <div className="period-selector">
        <button
          className={`period-btn ${period === 'all' ? 'active' : ''}`}
          onClick={() => setPeriod('all')}
        >
          All Time
        </button>
        <button
          className={`period-btn ${period === 'month' ? 'active' : ''}`}
          onClick={() => setPeriod('month')}
        >
          This Month
        </button>
        <button
          className={`period-btn ${period === 'week' ? 'active' : ''}`}
          onClick={() => setPeriod('week')}
        >
          This Week
        </button>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading leaderboard...</p>
        </div>
      ) : leaderboard.length === 0 ? (
        <div className="no-leaderboard">
          <p>No leaderboard data available yet.</p>
        </div>
      ) : (
        <div className="leaderboard-list">
          {leaderboard.map((student, index) => (
            <div
              key={student.id}
              className={`leaderboard-item ${index < 3 ? 'top-three' : ''}`}
            >
              <div className="rank">
                <span className="rank-icon">{getRankIcon(index)}</span>
              </div>
              <div className="student-info">
                <div className="student-name">{student.name}</div>
              </div>
              <div className="student-points">
                <span className="points-icon">⭐</span>
                <span className="points-value">{student.totalPoints.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Leaderboard;

